var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 1.66675H6.66699C3.33366 1.66675 1.66699 3.33341 1.66699 6.66675V17.5001C1.66699 17.9584 2.04199 18.3334 2.50033 18.3334H13.3337C16.667 18.3334 18.3337 16.6667 18.3337 13.3334V6.66675C18.3337 3.33341 16.667 1.66675 13.3337 1.66675Z",
    stroke: "#33B469",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7583 6.53322L6.43332 10.8582C6.26666 11.0249 6.10833 11.3499 6.07499 11.5832L5.84166 13.2332C5.75833 13.8332 6.17499 14.2499 6.77499 14.1665L8.42498 13.9332C8.65831 13.8999 8.98333 13.7416 9.15 13.5749L13.475 9.24988C14.2167 8.50821 14.575 7.64155 13.475 6.54155C12.375 5.43321 11.5083 5.78322 10.7583 6.53322Z",
    stroke: "#33B469",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 7.1499C10.5083 8.45824 11.5333 9.49157 12.8499 9.85824",
    stroke: "#33B469",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.8c6a627fb3cf56cbda9c8b277a87c047.svg";
export { ForwardRef as ReactComponent };